import React, { useState, useEffect } from 'react';
import Login from './components/Login/Login';
import MenuScreen from './components/MenuScreen/MenuScreen';
import OptionsScreen from './components/OptionsScreen/OptionsScreen';
import VehiclePickup from './components/VehiclePickup/VehiclePickup';
import VehicleReturn from './components/VehicleReturn/VehicleReturn';
import GPSTracking from './components/GPSTracking/GPSTracking';

function App() {
  const [user, setUser] = useState(() => {
    try {
      const savedUser = localStorage.getItem('user_data');
      return savedUser ? JSON.parse(savedUser) : null;
    } catch (error) {
      console.error('Error parsing user data from localStorage:', error);
      localStorage.removeItem('user_data');
      localStorage.removeItem('auth_token');
      return null;
    }
  });
  const [currentScreen, setCurrentScreen] = useState('menu');

  const handleLogin = (userData) => {
    setUser(userData);
    setCurrentScreen('menu');
  };

  const handleLogout = () => {
    setUser(null);
    setCurrentScreen('menu');
    localStorage.removeItem('auth_token');
    localStorage.removeItem('user_data');
  };

  const handleNavigate = (screen) => {
    setCurrentScreen(screen);
  };

  if (!user) {
    return <Login onLogin={handleLogin} />;
  }

  // Render different screens based on currentScreen state
  switch (currentScreen) {
    case 'menu':
      return <MenuScreen onNavigate={handleNavigate} user={user} />;
    case 'options':
      return <OptionsScreen onNavigate={handleNavigate} onBack={() => setCurrentScreen('menu')} />;
    case 'pickup':
      return <VehiclePickup onNavigate={handleNavigate} />;
    case 'return':
      return <VehicleReturn onBack={() => setCurrentScreen('options')} />;
    case 'gps-tracking':
      return <GPSTracking onBack={() => setCurrentScreen('menu')} />;
    default:
      return <MenuScreen onNavigate={handleNavigate} user={user} />;
  }
}

export default App;